import Favicon from 'react-favicon';
import { Helmet } from 'react-helmet';
import { FAVICON_ANIMATION_DELAY, FAVICON_FRAMES } from '../../constants/favicon-file-names';
import { Spinner } from '../design/Spinner';
export const DefaultSuspenseFallback = () => {
  return (
    <>
      <Helmet>
        <title>Loading...</title>
      </Helmet>
      <Favicon
        animationDelay={FAVICON_ANIMATION_DELAY}
        url={FAVICON_FRAMES}
      />
      <Spinner centerPage/>
    </>
  );
};